import {DefaultConfig} from "../default";
import {Salutation} from "../../types/enums";

export default class Config extends DefaultConfig {
    id = 'simde';
    name = 'sim.de';
    trademark = 'SIMDE';
    salutation = Salutation.DU;
    botChatDomain = 'chat.sim.de';
    agentChatDomain = 'livechat.sim.de';
    trademarkWebsite = 'https://www.sim.de';
}
